<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <div v-if="!isLoading && items.length === 0" class="text-main-color font-weight-500 text-center font-size-18">
            「{{ searchKeyword }}」沒有搜尋結果
            <div class="mt-3"></div>
          </div>

          <!-- <div v-if="items.length > 0" class="text-main-color font-weight-500 text-center font-size-18">
            共有 {{ total_counts }} 項結果
            <div class="mt-3"></div>
          </div> -->

          <div class="bg-white p-3 rounded-3" v-if="items.length > 0">
            <div>
              <h2 class="display-3 text-custom-text">搜尋結果：{{ searchKeyword }}</h2>
            </div>
            <div class="mt-3"></div>
            <div class="grid-container mx-5">
              <div v-for="(item, index) in items" :key="index" class="grid-item">
                <CatalogItem style="width: 212px;" :item="item"/>
              </div>
            </div>
            <IntersectionObserver
                sentinal-name="sentinal-name"
                @on-intersection-element="onIntersectionElement"
            />
            <div v-if="isLoadMore || finished" class="d-flex w-100 mt-3 justify-content-center align-items-center">
              <b-spinner v-if="isLoadMore" label="Loading..."></b-spinner>
              <p v-if="finished">已無更多資料</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CatalogItem from "@/views/components/elements/CatalogItem";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import * as Api from "@/util/http_api";

export default {
  name: "SearchView",
  components: {
    IntersectionObserver,
    CatalogItem,
  },
  data() {
    return {
      searchKeyword: '',
      isLoading: false,
      finished: false,
      items: [],
      total_counts: 0,
      isIntersectingElement: false,
      isLoadMore: false,
      itemsPerPage: 24,
    };
  },
  watch: {
    '$route'(to) {
      this.searchKeyword = to.query.q || '';
      this.reset();
      this.getDataFromApi();
    }
  },
  async created() {
    this.searchKeyword = this.$route.query.q || '';
    await this.getDataFromApi();
  },
  methods: {
    reset() {
      this.items = [];
      this.total_counts = 0;
      this.finished = false;
      this.isLoadMore = false;
    },
    onIntersectionElement(value) {
      this.isIntersectingElement = value;
      this.loadMore();
    },
    async loadMore() {
      if (this.isLoadMore || this.finished) return;
      this.isLoadMore = true;
      let data = await this.fetchItems(this.items.length, this.items.length + this.itemsPerPage - 1);
      for (let i = 0; i < data.items.length; i++) {
        this.items.push(data.items[i]);
      }
      this.isLoadMore = false;
      this.finished = this.items.length >= this.total_counts;
    },
    async getDataFromApi() {
      this.isLoading = true;
      try {
        let data = await this.fetchItems(0, this.itemsPerPage - 1);
        this.items = data.items;
        this.total_counts = data.total;
        this.finished = this.items.length >= this.total_counts;
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    async fetchItems(offsetStart, offsetEnd) {
      const filter = {};
      if (this.searchKeyword) {
        filter['q'] = this.searchKeyword;
      }
      const listOptions = {
        limit: offsetEnd - offsetStart + 1,
        offset: offsetStart,
        sorts: [['publish_date', 'DESC']],
        filters: filter,
      };
      const data = await Api.getCatalogs(listOptions);
      return {
        items: data.items,
        total: data.total,
      };
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
}

.grid-item {
  padding: 0;
}
</style>
